<template>
  <div>
    <div v-for="(cartProduct, index) in products" :key="index">
      <div class="cart-box-product" v-if="productAmounts[cartProduct.id] > 0">
        <div class="cart-box-product__img-container justify-content-center d-flex align-items-center py-2">
          <img :src="cartProduct.image" class="cart-box-product__img" :alt="cartProduct.name" @error="setAltImg" />
        </div>
        <div class="cart-box-product__content">
          <div class="d-flex align-items-center w-100">
              <a :href="cartProduct.url" class="cart-box-product__title notranslate">
                {{ cartProduct.name }}
              </a>
          </div>

          <div class="d-flex justify-content-between align-items-center">
            <div class="cart-box-product__basket">
              <div v-if="productAmounts[cartProduct.id] > 0" class="add-cart">
                <button class="add-cart__button" @click="changeProductAmount(cartProduct, productAmounts[cartProduct.id] - 1)">-</button>

                <input
                    :id="`counter-${cartProduct.id}`"
                    class="add-cart__input"
                    :value="productAmounts[cartProduct.id]"
                    type="number"
                    @change="inputAmountChanged(cartProduct, $event)"
                />

                <label class="add-cart__pieces">{{ dictionary.pieces }}</label>

                <button v-if="productAmounts[cartProduct.id] < cartProduct.maxAmountPerOrder"
                        class="add-cart__button add-cart__button--lg"
                        :disabled="productAmounts[cartProduct.id] >= cartProduct.maxAmountPerOrder"
                        :title="
                    productAmounts[cartProduct.id] >= cartProduct.maxAmountPerOrder ? cartProduct.maxAmountPerOrderWarning : dictionary.pieces
                  "
                        @click="changeProductAmount(cartProduct, productAmounts[cartProduct.id] + 1)"
                >
                  +
                </button>
              </div>
            </div>

            <div class="cart-box-product__price">
              <span class="cart-box-product__price__text notranslate" v-html="$formatCurrency(cartProduct.price.price * productAmounts[cartProduct.id])"></span>
            </div>
            <div class="cart-box-product__close text-end">
              <button class="cart-box-product__close__button" @click="changeProductAmount(cartProduct, 0)">×</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="productAmounts[cartProduct.id] >= cartProduct.maxAmountPerOrder" class="maxAmountPerOrder">
        {{ dictionary.maxAmountPerOrder }}
      </div>
    </div>

    <div v-for="(cartProduct, index) in deposits" :key="index">
      <div class="cart-box-product" v-if="productAmounts[cartProduct.id] > 0">
        <div class="cart-box-product__img-container justify-content-center d-flex align-items-center py-2">
          <img :src="cartProduct.image" class="cart-box-product__img" :alt="cartProduct.name" @error="setAltImg" />
        </div>
        <div class="cart-box-product__content">
          <div class="d-flex align-items-center w-100">
            <a :href="cartProduct.url" class="cart-box-product__title notranslate">
              {{ cartProduct.name }}
            </a>
          </div>
        </div>
        <div class="cart-box-product__count">
          {{ productAmounts[cartProduct.id] }} {{ dictionary.pieces }}
        </div>
        <div class="cart-box-product__price cart-box-product__price-deposit">
          <span class="cart-box-product__price__text notranslate" v-html="$formatCurrency(cartProduct.price.price * productAmounts[cartProduct.id])"></span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      isCompleteProductListShown: false,
      maxShowItem: 3,
    };
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    deposits: {
      type: Array,
      required: true,
    },
    productAmounts: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
  },
  methods: {

    showAll() {
      this.isCompleteProductListShown = true;
      this.maxShowItem = this.products.length + 1;
    },

    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    inputAmountChanged(product, $event) {
      this.changeProductAmount(product, parseInt($event.target.value));
    },

    changeProductAmount(product, amount) {
      this.$emit('addProductToBasket', {
        product,
        amount,
        showPreBasket: false,
        itemListName: 'Navigation_cart_box',
      })
    },

    setAltImg(event) {
      event.target.src = "/nuxt-assets/images/lazy-load-error.svg";
    },
  },
};
</script>

<style lang="scss">
$cart-box-product-pc-img: 60px;
$cart-box-product-pc-basket: 160px;
$cart-box-product-pc-price: 75px;
$cart-box-product-pc-close: 40px;
$pink-dark: #d3007d;
$primary: #e6007e;
$white: #fff;

.site-header__right .cart-box-product {
  display: flex;
  align-items: center;
  margin: 0.5em 0;

  &__img-container {
    width: $cart-box-product-pc-img;
    height: 50px;
  }

  &__img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
  }

  &__content {
    padding-left: 0.5em;
    position: relative;
    width: 100%;

    @media (min-width: 992px) {
      display: flex;
    }
  }

  &__title {
    flex-grow: 1;
    padding-right: 10%;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: calc(100% - #{$cart-box-product-pc-close});
    align-items: center;
    justify-content: center;
    color: #333;
    display: block;
    line-height: 17px;
    text-decoration: none;

    @media (min-width: 992px) {
      padding-right: 0.5em;
      width: 100%;
    }
  }

  &__basket {
    width: $cart-box-product-pc-basket;
  }

  &__count {
    width: $cart-box-product-pc-basket;
    text-align: left;
  }

  &__price {
    width: $cart-box-product-pc-price;
    text-align: right;
    line-height: 20px;

    &__text {
      display: block;
      font-weight: 700;
      color: #e6007e;
    }

    &__pieces {
      font-size: 12px;
    }
  }

  &__price-deposit {
    margin-right: 26px;
  }

  &__close {
    top: 0;
    right: 0;
    width: $cart-box-product-pc-close;

    @media (max-width: 992px) {
      position: absolute;
      height: 100%;
      display: flex;
      align-items: center;
      padding-bottom: 45px;
    }

    &__button {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      font-size: 22px;
      line-height: 16px;
      background: none;
      border: 0;
      color: #333333;
      cursor: pointer;
    }
  }
}

.site-header .search__product__button .add-cart {
  margin-top: 5px;
  min-height: 31px;
  min-width: 125px;

  @media (min-width: 980px) {
    min-width: 160px;
  }
}

.site-header .add-cart,
.product .add-cart {
  &__button {
    display: inline-flex;
    justify-content: center;
    background: $white;
    border-radius: 50px;
    border: 1px solid $primary;
    color: $primary;
    width: 29px;
    height: 29px;
    line-height: 19px;
    font-weight: 500;
    align-items: center;

    &__big {
      width: 100%;
      height: auto;
      padding: 5px 15px;
    }

    &--lg {
      width: 45px;
      background: $primary;
      color: #fff;

      &:disabled {
        background: #ddd;
        border: 1px solid #ddd;

        &:hover {
          cursor: not-allowed;
          background: #ddd;
          border: 1px solid #ddd;
        }
      }
    }

    &:hover {
      background-color: #d3007d;
      color: #fff;
      cursor: pointer;
    }
  }

  &__input {
    background: none;
    border: 0;
    text-align: right;
    padding-right: 3px;
    border-radius: 3px;
    margin-left: 2px;
    width: 29px;
    height: 25px;
    -webkit-appearance: none;
    -moz-appearance: textfield;

    @media (min-width: 890px) {
      font-size: 14px;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__pieces {
    padding-right: 20px;
    display: inline-block;
    margin: 0;
    height: 25px;
    line-height: 25px;
  }
}

.maxAmountPerOrder {
  text-align: center;
  margin: 5px 0;
  background: #ddd;
  padding: 5px;
  border-radius: 5px;
}
</style>
